/**
 * Port of C# GeneratePreprocessMetadata.cs
 * Creates preprocessed templates by parsing their structure
 */

import { PreprocessedTemplate } from '../../model/index.js';
import { parseSlottedTemplates } from './generatePreProcessMetadata_Slot.js';
import { parsePlaceholderTemplates } from './generatePreProcessMetadata_Placeholder.js';
import { parseJsonKeyPlaceholders } from './generatePreProcessMetadata_JsonKey.js';
import { parseJsonArrayPlaceholders, parseJsonArraySkipPlaceholders } from './generatePreProcessMetadata_Array.js';

/**
 * Creates a preprocessed template by parsing its structure
 * This method handles parsing only, leaving JSON preprocessing for later phase
 */
export function preprocessTemplate(content: string, appSite: string, templateKey: string, actualTemplateName: string): PreprocessedTemplate {
    const template = new PreprocessedTemplate();
    template.originalContent = content;
    template.actualTemplateName = actualTemplateName;

    if (!content) {
        return template;
    }

    // Parse template structure
    parseSlottedTemplates(content, appSite, template);
    parsePlaceholderTemplates(content, appSite, template);
    parseJsonKeyPlaceholders(content, template);
    parseJsonArrayPlaceholders(content, template);
    parseJsonArraySkipPlaceholders(content, template);

    template.jsonKeyPlaceholders = template.jsonKeyPlaceholders.filter(keyPlaceholder =>
        !template.jsonArraySkipPlaceholders.some(arraySkipPlaceholder =>
            keyPlaceholder.startIndex >= arraySkipPlaceholder.startIndex &&
            keyPlaceholder.endIndex <= arraySkipPlaceholder.endIndex));

    // Clean up: Remove JsonArrayPlaceholders that are inside slotted templates
    // These are already captured in the SlottedTemplates structure and should not be processed separately
    if (template.slottedTemplates.length > 0 && template.jsonArrayPlaceholders.length > 0) {
        const arrayPlaceholdersToRemove: typeof template.jsonArrayPlaceholders[number][] = [];
        for (const arrayPlaceholder of template.jsonArrayPlaceholders) {
            for (const slottedTemplate of template.slottedTemplates) {
                if (arrayPlaceholder.startIndex >= slottedTemplate.startIndex &&
                    arrayPlaceholder.endIndex <= slottedTemplate.endIndex) {
                    arrayPlaceholdersToRemove.push(arrayPlaceholder);
                    break;
                }
            }
        }
        for (const toRemove of arrayPlaceholdersToRemove) {
            const idx = template.jsonArrayPlaceholders.indexOf(toRemove);
            if (idx !== -1) {
                template.jsonArrayPlaceholders.splice(idx, 1);
            }
        }
    }

    return template;
}
